var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":_vm.label,"value":_vm.value,"rules":[_vm.rules.postalCode]},on:{"input":_vm.makeUppercase}})}
var staticRenderFns = []

export { render, staticRenderFns }